import { original } from "@reduxjs/toolkit";
import { FaCheck, FaFileDownload } from "react-icons/fa";
import { CheckCircle, DownloadCloud, XCircle } from "lucide-react";

const getInvoiceData = (t) => {
  const invoicesColumns = [
    {
      Header: t("invoices.invoiceNo"),
      accessor: "id",
      sortable: true,
    },
    {
      Header: t("invoices.date"),
      accessor: "cutDate",
      sortable: true,
    },
    {
      Header: t("invoices.amount"),
      accessor: "amount",
      Cell: ({ row: { original } }) => <>{original.amount}€</>,
    },
    {
      Header: t("invoices.description"),
      accessor: "description",
      sortable: true,
    },
    {
      Header: t("invoices.download"),
      accessor: "downloadUrl",
      sortable: false,
      Cell: ({ row: { original } }) => (
        <>
          {original.downloadUrl && (
            <a
              href={`${process.env.REACT_APP_POS2CLOUD_IMAGE_URL}/${original.downloadUrl}`}
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              <DownloadCloud className="w-5 h-5 text-blue-600 hover:text-blue-800" />
            </a>
          )}
        </>
      ),
    },
    {
      Header: t("invoices.paid"),
      accessor: "isPaid",
      sortable: true,
      Cell: ({ row: { original } }) => (
        <>
          {original.isPaid ? (
            <CheckCircle className="text-green-500 w-5 h-5" />
          ) : (
            <XCircle className="text-red-500 w-5 h-5" />
          )}
        </>
      ),
    },
  ];

  return { invoicesColumns };
};

export default getInvoiceData;
